import { format } from 'date-fns';
import { CommentsSide } from '../../../../modules/Essay/components/Comments';
import { CorrectionImage } from '../../../../modules/Essay/components/CorrectedImage';
import { ScoresHeader } from '../../../../modules/Essay/components/Corrected/ScoresHeader';
import { IFeedback } from '../../../models/essay';
import { Typography } from '../../molecules/Typography';
import EssayCorrectedPaper from '../../../../modules/Essay/components/CorrectionPaper';

interface IEssayPrint {
  feedback: IFeedback;
}

const EssayPrint: React.FC<IEssayPrint> = ({ feedback }) => {
  return (
    <div className='flex flex-col gap-md'>
      <div className='flex flex-col gap-xl rounded-md bg-white p-5 shadow-level-1'>
        <div className='flex flex-col items-center gap-xxl'>
          <div className='w-full'>
            <Typography
              type='titleSection'
              size='h6'
              className='text-center uppercase text-[#000]'
            >
              Nota final
            </Typography>
            <Typography
              type='title'
              size='h1'
              className='text-center text-primary-500'
            >
              {feedback?.finalScore}
            </Typography>
          </div>
          <div className='w-full'>
            <Typography weight='bold' className='text-[#000]'>
              Comentário final
            </Typography>
            <Typography className='break-all italic text-[#000]'>
              {feedback?.comentario_geral}
            </Typography>
          </div>
          <div className='flex flex-col'>
            <ScoresHeader
              defaultOpen={true}
              scores={feedback.scores}
              correction={feedback.theme.correctionType}
            />
          </div>
        </div>
        {feedback.response_type === 'Revisão' &&
          feedback.comentario_revisao !== null && (
            <div className='flex flex-col gap-md bg-warning-100 px-4 py-3'>
              <Typography weight='bold'>
                Mensagem da moderação do aprova
              </Typography>
              <Typography className='italic text-[#000]'>
                {feedback.comentario_revisao}
              </Typography>
              <Typography className='text-[#000]'>
                {format(
                  new Date(
                    feedback.revisions[feedback.revisions.length - 1].createdAt
                  ),
                  'dd/MM/yyyy'
                )}
                às
                {format(
                  new Date(
                    feedback.revisions[feedback.revisions.length - 1].createdAt
                  ),
                  'HH:mm'
                )}
              </Typography>
            </div>
          )}
        <div className='mb-4'>
          <Typography
            weight='bold'
            type='titleSection'
            size='h3'
            className='text-[#000]'
          >
            Redação
          </Typography>
        </div>
        <div className='flex flex-col gap-xxl'>
          <div className='w-full'>
            {!feedback.image ? (
              <EssayCorrectedPaper
                essayText={feedback?.rawText || ''}
                essayTitle=''
                fontSize='default'
                correction={feedback?.theme.correctionType || 2}
                provider={feedback?.provider || ''}
                comments={feedback?.comments || ''}
                isLoading={false}
              />
            ) : (
              <CorrectionImage
                rotation={feedback.rotate ?? 0}
                imageUrl={feedback.image}
                imageMap={feedback.comment_map}
                comments={feedback.comments}
              />
            )}
          </div>
          <CommentsSide
            provider={feedback.provider}
            comments={feedback.comments}
            correction={feedback.theme.correctionType}
            isPrint
          />
        </div>
      </div>
    </div>
  );
};

export default EssayPrint;
